import logo from '../assets/images/mimararchi.png';

const BlueProfile = ({name,job,image1}) => {
    return (
        <>
            <div className="mocketLogo">
                <img src={logo} alt="Profile Logo" />
            </div>
            <div className="imgHolderBlue">
                <div className="mocketImageBlue">
                    <img src={image1} alt="Profile 2" />
                </div>
            </div>
            <div className='nameHolder'>
                <h1 style={{"fontFamily":"neufile-name"}} > {name} </h1>
                <h4 style={{"fontFamily":"neufile-title","textAlign":"center"}}> {job}</h4>
            </div>
        </>
    )
}

export default BlueProfile